import React, { lazy } from 'react';
import ActionCreateTasksExalus from '../components/action-create/tasks';
import ActionTasksTypesExalus from '../components/action-create/tasks/task-types';
import { useIntegrationRoute } from '../hooks/router/use-integration-route';
import ActionCreateExalus from '../integrations/exalus/modules/action-create';
import ActionTasksVariantsExalus from '../integrations/exalus/modules/action-create/tasks/task-variants';
import ActionChannelSettingsExalus from '../integrations/exalus/modules/action-create/tasks/task-variants/channel-settings';
import DeviceVariantsExalus from '../integrations/exalus/modules/action-create/tasks/task-variants/devices-variants';
import ActionListExalus from '../integrations/exalus/modules/action-list';
import ChannelConfigurationExalus from '../integrations/exalus/modules/channel-configuration';
import ChannelDetailsExalus from '../integrations/exalus/modules/channel-details';
import ChannelListExalus from '../integrations/exalus/modules/channel-list';
import ChannelsVisibilityExalus from '../integrations/exalus/modules/channels-visiblity';
import DashboardExalus from '../integrations/exalus/modules/dashboard';
import DeviceDetailsExalus from '../integrations/exalus/modules/device-details';
import DeviceListExalus from '../integrations/exalus/modules/device-list';
import DeviceListProvider from '../integrations/exalus/modules/device-list/context';
import GroupSortChannelsExalus from '../integrations/exalus/modules/group-sort-channels';
import GroupCreateExalus from '../integrations/exalus/modules/group/create';
import GroupEditExalus from '../integrations/exalus/modules/group/edit';
import GroupListExalus from '../integrations/exalus/modules/group/group-list';
import GroupSortExalus from '../integrations/exalus/modules/group/group-sort';
import ActionCreateLavva from '../integrations/lavva/modules/action-create/steps/name-icon-form';
import ActionCreateTasksLavva from '../integrations/lavva/modules/action-create/steps/task-list';
import ActionTasksTypesLavva from '../integrations/lavva/modules/action-create/steps/task-types';
import ActionTasksVariantsLavva from '../integrations/lavva/modules/action-create/steps/task-variants';
import ActionChannelSettingsLavva from '../integrations/lavva/modules/action-create/steps/task-variants/channel-settings';
import DeviceVariantsLavva from '../integrations/lavva/modules/action-create/steps/task-variants/devices-variants';
import ActionListLavva from '../integrations/lavva/modules/action-list';
import ChannelConfigurationLavva from '../integrations/lavva/modules/channel-configuration';
import ChannelDetailsLavva from '../integrations/lavva/modules/channel-details';
import ChannelListLavva from '../integrations/lavva/modules/channel-list';
import ChannelsVisibilityLavva from '../integrations/lavva/modules/channels-visiblity';
import DashboardLavva from '../integrations/lavva/modules/dashboard';
import DeviceListLavva from '../integrations/lavva/modules/device-list';
import DeviceDetailsLavva from '../integrations/lavva/modules/device-settings';
import GroupListLavva from '../integrations/lavva/modules/group-list';
import GroupSortLavva from '../integrations/lavva/modules/group-sort';
import GroupSortChannelsLavva from '../integrations/lavva/modules/group-sort-channels';
import GroupCreateLavva from '../integrations/lavva/modules/group/create';
import GroupEditLavva from '../integrations/lavva/modules/group/edit';

export const GroupList: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupListLavva />, Exalus: <GroupListExalus /> });
export const ActionList: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionListLavva />, Exalus: <ActionListExalus /> });
export const Dashboard: React.FC = () =>
  useIntegrationRoute({ Lavva: <DashboardLavva />, Exalus: <DashboardExalus /> });
export const ChannelList: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelListLavva />, Exalus: <ChannelListExalus /> });
export const GroupCreate: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupCreateLavva />, Exalus: <GroupCreateExalus /> });
export const GroupEdit: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupEditLavva />, Exalus: <GroupEditExalus /> });
export const DeviceList: React.FC = () =>
  useIntegrationRoute({
    Lavva: <DeviceListLavva />,
    Exalus: (
      <DeviceListProvider>
        <DeviceListExalus />
      </DeviceListProvider>
    ),
  });
export const DeviceDetails: React.FC = () =>
  useIntegrationRoute({ Lavva: <DeviceDetailsLavva />, Exalus: <DeviceDetailsExalus /> });
export const ChannelDetails: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelDetailsLavva />, Exalus: <ChannelDetailsExalus /> });
export const ChannelConfiguration: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelConfigurationLavva />, Exalus: <ChannelConfigurationExalus /> });
export const ChannelsVisibility: React.FC = () =>
  useIntegrationRoute({ Lavva: <ChannelsVisibilityLavva />, Exalus: <ChannelsVisibilityExalus /> });
export const GroupSort: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupSortLavva />, Exalus: <GroupSortExalus /> });
export const GroupSortChannels: React.FC = () =>
  useIntegrationRoute({ Lavva: <GroupSortChannelsLavva />, Exalus: <GroupSortChannelsExalus /> });
export const ActionCreate: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateLavva />, Exalus: <ActionCreateExalus /> });
export const ActionCreateTasks: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateTasksLavva />, Exalus: <ActionCreateTasksExalus /> });
export const ActionTasksTypes: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionTasksTypesLavva />, Exalus: <ActionTasksTypesExalus /> });
export const ActionTasksVariants: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionTasksVariantsLavva />, Exalus: <ActionTasksVariantsExalus /> });
export const ActionDeviceVariants: React.FC = () =>
  useIntegrationRoute({ Lavva: <DeviceVariantsLavva />, Exalus: <DeviceVariantsExalus /> });
export const ActionChannelSettings: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionChannelSettingsLavva />, Exalus: <ActionChannelSettingsExalus /> });
export const ActionEdit: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateLavva />, Exalus: <ActionCreateExalus /> });
export const ActionEditTasks: React.FC = () =>
  useIntegrationRoute({ Lavva: <ActionCreateTasksLavva />, Exalus: <ActionCreateTasksExalus /> });
